import IconButton from 'storybookConfig/stories/molecules/Button/IconButton';
import { type RootState, useAppDispatch, useAppSelector } from 'store/index';
import { closeMobileMenu, openMobileMenu } from 'store/slices/sidebar';
import type { ThemeColor } from 'storybookConfig/stories/theme';

interface HamburgerProps {
  color?: ThemeColor;
}

const Hamburger = ({ color }: HamburgerProps) => {
  const { mobileMenuExpanded } = useAppSelector((state: RootState) => state.sidebar);

  const dispatch = useAppDispatch();
  return (
    <IconButton
      aria-label={mobileMenuExpanded ? 'Close menu' : 'Open menu'}
      onClick={() => dispatch(mobileMenuExpanded ? closeMobileMenu() : openMobileMenu())}
      name="menu"
      size="large"
      color={color || 'bodyTextPrimary'}
    />
  );
};

export default Hamburger;
